import axios from 'axios';
import { store } from './store';
import { userActions } from '../actions/user.actions';

const client = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 90000,
});

// Add authorization header
client.interceptors.request.use(
  async config => {
    const token = JSON.parse(localStorage.getItem('token'));

    // Add token if set
    if (token && token.access_token) {
      config.headers.authorization = `Bearer ${token.access_token}`;
    }    
    config.headers.pragma = 'no-cache';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add 401 interceptor check
client.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (401 === error.response.status) {
      const { dispatch } = store;
      dispatch(userActions.logout());
    } else {
        return Promise.reject(error);
    }
  }
);

export default client;
